<mat-toolbar>
  <div style="display: flex; width: 100%; justify-content: space-between; align-items: center;">
    <!-- Contenedor izquierdo -->
    <div style="display: flex; align-items: center;">
      <button mat-icon-button (click)="toggleMenu()" style="cursor: pointer;">
        <mat-icon style="cursor: pointer;">menu</mat-icon>
      </button>
      <div class="logo"></div>
    </div>

    <!-- Contenedor derecho -->
    <div style="display: flex; align-items: center; margin-left: auto;">
      <!-- Icono de chat -->
      <button 
        mat-icon-button 
        [matMenuTriggerFor]="chatMenu" 
        style="cursor: pointer; margin-right: 1rem; position: relative;"
      >
        <mat-icon style="cursor: pointer;">chat</mat-icon>
        <span *ngIf="pendingMessages.length > 0" matBadge="{{ pendingMessages.length }}" matBadgeColor="warn" class="badge-position"></span>
      </button>
      <mat-menu #chatMenu="matMenu">
        <ng-container *ngIf="pendingMessages.length > 0; else noMessages">
          <button 
            mat-menu-item 
            *ngFor="let message of pendingMessages" 
            class="chat-menu-item"
            (click)="navigateToChat(message.service_id)"
          >
            <p>
              Tienes {{ message.count }} mensajes pendientes del servicio {{ message.service_id }}
            </p>
          </button>
        </ng-container>
        <ng-template #noMessages>
          <button mat-menu-item disabled>
            <p>No hay mensajes pendientes</p>
          </button>
        </ng-template>
      </mat-menu>

      <!-- Menú de usuario -->
      <a class="option-toolbar" [matMenuTriggerFor]="menu">
        <div class="list-item-content">
          <mat-icon class="icon">supervisor_account</mat-icon>
          <span>{{userInfo?.name}}</span>
          <mat-icon class="icon">keyboard_arrow_down</mat-icon>
        </div>
      </a>
      <mat-menu #menu="matMenu">
        <button mat-menu-item>
          <mat-icon>account_circle</mat-icon>
          <span>Mi perfil</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="cityMenu">
          <mat-icon>location_city</mat-icon>
          <span>{{ selectedCity.name }}</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Cerrar sesión</span>
        </button>
      </mat-menu>

      <mat-menu #cityMenu="matMenu">
        <button mat-menu-item *ngFor="let city of cities" (click)="setSelectedCity(city)">
          {{ city.name }}
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>

  <mat-sidenav-container autosize class="sidenav">
    <mat-sidenav #sidenav  mode="side" [(opened)]="isExpanded" class="sidenav">
      <div class="sidenav-content">
        <mat-nav-list class="nav-list">
          <!-- <a mat-list-item routerLink="/home" class="option">
            <div class="list-item-content">
              <mat-icon 
                mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">home</mat-icon>
              <span class="option-name" mat-line *ngIf="isExpanded">Dashboard</span>
            </div>
          </a> -->

          <p class="title-nav">Servicios</p>

          <a mat-list-item routerLink="/orders-create" class="option">
            <div class="list-item-content">
              <mat-icon 
                mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">library_add</mat-icon>
              <span class="option-name" mat-line *ngIf="isExpanded">Generar Servicios</span>
            </div>
          </a>
    
            <a mat-list-item routerLink="/orders-assignement" class="option" >
              <div class="list-item-content">
                <mat-icon 
                  mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">assignment_ind</mat-icon>
                <span class="option-name" mat-line *ngIf="isExpanded">Asignar Servicios</span>
              </div>
            </a>
    
            <a mat-list-item routerLink="/orders-support" class="option">
              <div class="list-item-content">
                <mat-icon 
                  mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">commute</mat-icon>
                <span class="option-name" mat-line *ngIf="isExpanded">Gestión Servicios</span>
              </div>
            </a>

              <p class="title-nav">Servicios Manuales</p>
            <a mat-list-item routerLink="/manual-services" class="option">
              <div class="list-item-content">
                <mat-icon 
                  mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">assignment</mat-icon>
                <span class="option-name" mat-line *ngIf="isExpanded">Servicios Manuales</span>
              </div>  
            </a>

            <p class="title-nav" *ngIf="userRoleId === 3">Data exportada</p>
            <a mat-list-item routerLink="/exported-data" class="option" *ngIf="userRoleId === 3">
              <div class="list-item-content">
                <mat-icon 
                  mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">backup</mat-icon>
                <span class="option-name" mat-line *ngIf="isExpanded">Data Exportada</span>
              </div>
            </a>
          

         
          <p class="title-nav">Riders</p>
          <a mat-list-item routerLink="/riders" class="option">
            <div class="list-item-content">
              <mat-icon 
                mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">motorcycle</mat-icon>
              <span class="option-name" mat-line *ngIf="isExpanded">Gestión Riders</span>
            </div>
          </a>

          <p class="title-nav">Aliados</p>
          <a mat-list-item routerLink="/partners" class="option">
            <div class="list-item-content">
              <mat-icon 
                mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">store</mat-icon>
              <span class="option-name" mat-line *ngIf="isExpanded">Gestión Aliados</span>
            </div>
          </a>


          <p class="title-nav">Usuarios</p>
          <a mat-list-item routerLink="/users" class="option">
            <div class="list-item-content">
              <mat-icon 
                mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">supervised_user_circle</mat-icon>
              <span class="option-name" mat-line *ngIf="isExpanded">Gestión Usuarios</span>
            </div>
          </a>

          <!-- <p class="title-nav">Horarios</p>
          <a mat-list-item routerLink="/schedule-management" class="option">
            <div class="list-item-content">
              <mat-icon 
                mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">supervised_user_circle</mat-icon>
              <span class="option-name" mat-line *ngIf="isExpanded">Horarios</span>
            </div>
          </a> -->

           <p class="title-nav" *ngIf="userRoleId === 3">Facturación</p>
          <a mat-list-item routerLink="/payments-support" class="option" *ngIf="userRoleId === 3">
            <div class="list-item-content">
              <mat-icon 
                mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">supervised_user_circle</mat-icon>
              <span class="option-name" mat-line *ngIf="isExpanded">Facturación</span>
            </div>
          </a>

          <!-- <p class="title-nav">Historial</p>
          <a mat-list-item routerLink="/orders-history" class="option">
            <div class="list-item-content">
              <mat-icon 
                mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">list</mat-icon>
              <span class="option-name" mat-line *ngIf="isExpanded">Historial de servicios</span>
            </div>
          </a> -->

    
          <!-- <a mat-list-item routerLink="/orders-create" class="option">
            <div class="list-item-content">
              <mat-icon 
                mat-list-icon [matTooltip]="!isExpanded ? 'Logística' : null" matTooltipPosition="right" class="icon">supervised_user_circle</mat-icon>
              <span class="option-name" mat-line *ngIf="isExpanded">Crear ordeners</span>
            </div>
          </a> -->

        </mat-nav-list>
        <!-- <a mat-list-item class="option logout-option" (click)="logout()">
          <div class="list-item-content">
            <mat-icon 
              mat-list-icon [matTooltip]="!isExpanded ? 'Cerrar sesión' : null" matTooltipPosition="right" class="icon">logout</mat-icon>
            <span class="option-name" mat-line *ngIf="isExpanded">Cerrar Sesión</span>
          </div>
        </a> -->
      </div>
      </mat-sidenav>
   
      <mat-sidenav-content>
      <div class="content-container">
        <router-outlet></router-outlet>
       
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  
  
